import React, { Component } from 'react'
import { Button } from 'reactstrap'
import { once } from "underscore"
import GenericModal from '../components/GenericModal'

const DEFAULT_STATE = {
    show: false,
    callback: null,
    callbackClose: null,
    callbackLabelClose: 'Fechar',
    callbackLabel: "Continuar",
    message: ""
}

export const AvisoContext = React.createContext(DEFAULT_STATE)

export class AvisoContextProvider extends Component {
    state = DEFAULT_STATE

    componentDidMount() {
        this.startListener()
    }

    startListener = once(() => [
        document.addEventListener("showAviso", (e) => {
            this.setState({ ...this.state, ...e.detail, show: true })
        })
    ])

    toggle = () => {
        if (this.state.callbackClose) {
            this.state.callbackClose()
        }

        this.setState({ ...this.state, show: !this.state.show })
    }

    reset = () => this.setState(DEFAULT_STATE)

    fireCallback = () => {
        this.state.callback()
        this.setState({ ...this.state, show: false })
    }

    closeModal = (e) => {
        if (e.target.classList?.contains("aviso-backdrop")) {
            this.toggle()
        }
    }

    render() {
        return (
            <AvisoContext.Provider value={this.state}>
                {this.props.children}
                <GenericModal 
                    isOpen={this.state.show}
                    hasConfirm={this.state.callback}
                    onConfirm={this.fireCallback}
                    onClose={this.toggle}
                    description={this.state.message}
                    title={this.state.title || 'Aviso'}
                    confirmText={this.state.callbackLabel || 'Continuar'}
                    cancelText={this.state.callbackLabelClose}
                />
            </AvisoContext.Provider>
        )
    }
}